import { PaymentMethodType } from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/payment_method_pb";

export const paymentMethodTypeToString = {
  [PaymentMethodType.UNSPECIFIED]: "Unspecified",
  [PaymentMethodType.CARD]: "Card",
  [PaymentMethodType.PAYPAL]: "PayPal Account",
};

export enum CardExpirationStatus {
  ACTIVE = "active",
  EXPIRING = "expiring",
  EXPIRED = "expired",
}
